export const TUTORIAL_TYPES = {
  CREATE_APARTMENT_TUTORIAL: 'CREATE_APARTMENT_TUTORIAL',
  CREATE_BUILDING_TUTORIAL: 'CREATE_BUILDING_TUTORIAL',
}
